import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import * as _ from 'lodash';

export function noWhitespaceValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		if (_.isEmpty(control.value)) return null;
		const isWhitespace = control.value.trim().length === 0;
		const isValid = !isWhitespace;
		return isValid ? null : {'whitespace': true};
	};
}
